import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { openDashboardDialog } from '@actions/dashboard-actions';
import * as dialog from '@constants/dialogs';
import { Button } from '@mui';
import { OVERLAP_ENTITY_STATUS } from '@utils/data-detail/conflicts';
import LoadingBox from './actions-loading-box';
import ResolveBox from './actions-resolve-box';
import './actions-box.scss';

const ActionsBox = ({ entity, isOpportunity, mainEntity, permissions }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.dashboard.resolution.loading);

  const [form, setForm] = useState(null);

  const onCloseForm = useCallback(() => setForm(null), []);

  const getStatus = useCallback(() => {
    const { overlap_status } = entity;
    if (overlap_status[0]) {
      const overlapId = overlap_status[0].overlap;
      return mainEntity.overlap_status.find(overlap => overlap.overlap === overlapId);
    }
    return [];
  }, [entity, mainEntity]);

  const onRevoke = useCallback(() => {
    const status = getStatus();
    const params = { status };
    dispatch(openDashboardDialog(dialog.OVERLAP_REVOKE, params));
  }, [dispatch, getStatus]);

  const onResolve = useCallback(() => setForm('resolve'), []);

  const isStatus = useCallback(key => {
    const status = getStatus();
    const { overlap_entity_status } = status;
    return overlap_entity_status === OVERLAP_ENTITY_STATUS[key];
  }, [getStatus]);

  const showResolve = useCallback(() => {
    const { resolve } = permissions;
    return resolve && !isOpportunity && isStatus('new');
  }, [isOpportunity, isStatus, permissions]);

  const showRevoke = useCallback(() => {
    const { revoke } = permissions;
    return revoke && !isOpportunity && isStatus('resolved');
  }, [isOpportunity, isStatus, permissions]);

  const isDisabled = form !== null || loading;

  return (
    <div styleName="actions-box-container">
      <div styleName="actions-buttons">
        {showResolve() && (
          <div styleName="button">
            <Button
              plain
              color="primary"
              disabled={isDisabled}
              onClick={onResolve}
              variant="contained"
            >
              RESOLVE
            </Button>
          </div>
        )}
        {showRevoke() && (
          <div styleName="button">
            <Button
              plain
              disabled={isDisabled}
              onClick={onRevoke}
              variant="outlined"
            >
              REVOKE
            </Button>
          </div>
        )}
      </div>
      <div styleName="actions-form">
        {form === 'resolve' && <ResolveBox entity={mainEntity} onClose={onCloseForm} />}
        <LoadingBox />
      </div>
    </div>
  );
};

ActionsBox.propTypes = {
  entity: PropTypes.object,
  isOpportunity: PropTypes.bool,
  mainEntity: PropTypes.object,
  permissions: PropTypes.object
};

export default ActionsBox;
